import { render, staticRenderFns } from "./SuccessPaymant.vue?vue&type=template&id=2522d7da&scoped=true&"
import script from "./SuccessPaymant.vue?vue&type=script&lang=js&"
export * from "./SuccessPaymant.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPaymant.vue?vue&type=style&index=0&id=2522d7da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522d7da",
  null
  
)

export default component.exports